const actionTypeIdentifier = 'E08361D1-95E1-4FC3-8B33-BE897444596F'; // to generate open ssms run select newid()

//location form actions
export const setSubscriptionDetails = `SET-WIRELESS-CHANGE-PRICE-PLAN-SUBSCRIPTION-DETAILS-${actionTypeIdentifier}`;
export const setVendorDetails = `SET-WIRELESS-CHANGE-PRICE-PLAN-VENDOR-DETAILS-${actionTypeIdentifier}`;
export const setPrimaryPlanDetails = `SET-WIRELESS-CHANGE-PRICE-PLAN-PRIMARY-PLAN-DETAILS-${actionTypeIdentifier}`;
export const setPlanOptions = `SET-WIRELESS-CHANGE-PRICE-PLAN-PLANS-OPTIONS-${actionTypeIdentifier}`;
export const setOtherPlanOptions = `SET-WIRELESS-CHANGE-PRICE-PLAN-OTHER-PLANS-OPTIONS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-WIRELESS-CHANGE-PRICE-PLAN-FORM-SUBMITTED-${actionTypeIdentifier}`;


export const wirelessChangePricePlanModel = {
    circuitCode: ''
    , circuitId: 0
    , planId: 0
    , planDetails: {
        planComponents: []
    }
    , planDetailsModel: []
    , businessJustification: ''
    , additionalInformation: ''
}